import { Stack } from "@mui/material";
import { IResourceComponentsProps } from "@refinedev/core";
import { useDataGrid } from "@refinedev/mui";
import EventCalendar from "components/Calendar/EventCalendar";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../receipt/list.css";
import { ReiceptToggleView } from "./components/ToggleViewHeader";
import { ReiceptListView } from "./components/ReiceptList";

export interface ReceiptsModel {
  id: number;
  day: string;
  receipts: Receipt[];
  start: string;
  end: string;
  percentage: string;
  total_paid: number;
  total_unpaid: number;
  total_amount_given: string;
  total_amount_received: string;
  total_receipts: number;
}

export interface Receipt {
  client_id: any;
  containers: Container[];
  receipt_number: string;
  amount_received: string;
  amount_given: any;
}

export interface Container {
  id: number;
  name: string;
  type: string;
}

export enum ReceiptModeEnum {
  calendar,
  list,
}

export const ReceiptList: React.FC<IResourceComponentsProps> = () => {
  const { dataGridProps } = useDataGrid();
  const [mode, setMode] = useState<ReceiptModeEnum>(ReceiptModeEnum.list);
  const rowsRaw = dataGridProps?.rows as ReceiptsModel[] | { data?: ReceiptsModel[] } | undefined;
  const data: ReceiptsModel[] = Array.isArray(rowsRaw)
    ? rowsRaw
    : rowsRaw && Array.isArray(rowsRaw.data)
      ? rowsRaw.data
      : [];

  const formatedData = data.map((item) => ({
    id: item?.id,
    title: "",
    start: new Date(item?.start),
    end: new Date(item?.end),
    percentage: item?.percentage,
    total_receipt: item?.receipts?.length,
    paid: item?.total_paid,
    unpaid: item?.total_unpaid,
    total_amount_given: item?.total_amount_given,
    total_amount_received: item?.total_amount_received,
  }));

  const navigate = useNavigate();

  const addDay = () => {
    navigate("/receipts/create", {
      state: {
        receipts_number: 1,
        day: new Date(),
      },
    });
  };

  return (
    <Stack direction="column" alignItems="start" width="100%">
      <ReiceptToggleView mode={mode} setMode={setMode} />
      {mode === ReceiptModeEnum.calendar ? (
        <Stack direction="column" alignItems="start" width="100%">
          <EventCalendar events={formatedData || []} />
        </Stack>
      ) : (
        <ReiceptListView
          addDay={addDay}
        />
      )}
    </Stack>
  );
};
